/**
 * Every string the UI shows comes from a resource file (CLAUDE.md
 * section 7). English first; Assamese (as) and Hindi (hi) are added as more
 * files with the same keys.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { ApiError } from "@/api/client";

import en from "./en.json";

export const resources = { en: { translation: en } } as const;

void i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false }, // React escapes already
  returnNull: false,
});

/**
 * A plain-language message for an error: the translation of its API code
 * when there is one, otherwise the server's own English detail.
 */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const key = `errors.${error.code ?? ""}`;
    if (error.code && i18n.exists(key)) {
      return i18n.t(key);
    }
    return error.message || i18n.t("errors.unknown");
  }
  if (error instanceof TypeError) {
    return i18n.t("errors.network"); // fetch failed: offline or unreachable
  }
  return i18n.t("errors.unknown");
}

export default i18n;
